// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_au-0";
export var optionCard = "_au-1";